module.exports = __webpack_public_path__ + "img/result_title.88de2f09.png";